import { EventNames } from '../constants/EventNames'
import { AkixiWindow } from '../Types/Types'
import { isVarNotEmpty } from './GlobalFunctions'

export const $window: AkixiWindow = window as AkixiWindow

/**
 * Attach event listener to window
 */
export const $addEventListener = <K extends keyof WindowEventMap>(
    event: K,
    callback: (e?: WindowEventMap[K]) => void,
    options?: boolean | AddEventListenerOptions
): void => {
    window.addEventListener(event, callback, options)
}

/**
 * Attach event listener to Body
 */
export const $addBodyEventListener = <K extends keyof HTMLElementEventMap>(
    event: K,
    callback: (e?: HTMLElementEventMap[K]) => void,
    options?: boolean | AddEventListenerOptions
): void => {
    document.body.addEventListener(event, callback, options)
}

/**
 * Dettach event listener to window
 */
export const $removeEventListener = <K extends keyof WindowEventMap>(
    event: K,
    callback: (e?: WindowEventMap[K]) => void,
    options?: boolean | EventListenerOptions
): void => {
    window.removeEventListener(event, callback, options)
}

/**
 * Dettach event listener to Body.
 * */
export const $removeBodyEventListener = <K extends keyof HTMLElementEventMap>(
    event: K,
    callback: (e?: HTMLElementEventMap[K]) => void,
    options?: boolean | EventListenerOptions
): void => {
    document.body.removeEventListener(event, callback, options)
}

export const getDocumentBody = (): Promise<HTMLBodyElement> =>
    new Promise<HTMLBodyElement>((resolve: (value: HTMLBodyElement) => void): void => {
        const body: HTMLBodyElement = document.body as HTMLBodyElement

        if (isVarNotEmpty(body)) {
            resolve(body)
        } else {
            $window.addEventListener(EventNames.LOAD, (): void => resolve(document.body as HTMLBodyElement))
        }
    })
